__turbopack_context__.v({
  "column": "style-module-scss-module__jHNkVa__column",
  "img": "style-module-scss-module__jHNkVa__img",
  "item": "style-module-scss-module__jHNkVa__item",
  "list": "style-module-scss-module__jHNkVa__list",
  "title": "style-module-scss-module__jHNkVa__title",
  "title__withoutLink": "style-module-scss-module__jHNkVa__title__withoutLink",
  "wrapper": "style-module-scss-module__jHNkVa__wrapper",
});
